import React from 'react';
// import PropTypes from 'prop-types';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import AclUsers from './AclUsers';
// import UserProfile from './UserProfile';

function UserRoutes() {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route path={`${match.path}/users`} component={AclUsers} />
      <Redirect to={`${match.url}/users`} />
    </Switch>
  );
}

UserRoutes.propTypes = {};

export default UserRoutes;
